import React from "react";
import { GOOGLE_REVIEWS_URL } from "../../constants/gmb";
import { useGmbReviews } from "../../context/GmbReviewsContext";
import "./GoogleReviewsSection.scss";

export default function GoogleReviewsSection() {
  const { featuredReviews, displayRating, ratingCount, loading, hasData } =
    useGmbReviews();

  if (loading && !hasData) {
    return (
      <section className="googleReviewsSection" aria-label="Google customer reviews">
        <div className="googleReviewsSectionContent">
          <p className="googleReviewsSectionSubtitle">Loading customer reviews…</p>
        </div>
      </section>
    );
  }

  if (!featuredReviews.length) {
    return null;
  }

  return (
    <section className="googleReviewsSection" aria-label="Google customer reviews">
      <div className="googleReviewsSectionContent">
        <div className="googleReviewsSectionHeader">
          <h2 className="googleReviewsSectionTitle">What Our Customers Say</h2>
          {hasData && (
            <p className="googleReviewsSectionSubtitle">
              {displayRating} on Google · {ratingCount} reviews
            </p>
          )}
        </div>

        <div className="googleReviewsGrid">
          {featuredReviews.map((review) => (
            <article key={review.id} className="googleReviewCard">
              <p className="googleReviewComment">{review.comment}</p>
              <p className="googleReviewAuthor">{review.firstName}</p>
              <p className="googleReviewDate">{review.monthLabel}</p>
            </article>
          ))}
        </div>

        <div className="googleReviewsSectionFooter">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="googleReviewsLink"
          >
            Read all reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
}
